<script setup lang="ts">
  import { ExternalRoute } from "@/constants/externalRoute"
  import { type EnrolmentRoute } from "@/constants/routes/enrolment"
  import { type MyAccountRoute } from "@/constants/routes/myAccount"
  import { cn } from "@/lib/utils.ts"
  import { Link } from "@/components/ui/link"

  const { to, label, disabled, exact } = defineProps<{
    to: MyAccountRoute | EnrolmentRoute | ExternalRoute
    label: string
    disabled?: boolean
    exact?: boolean
  }>()
</script>

<template>
  <li
    :class="
      cn(
        'nav pb-1',
        disabled && 'cursor-not-allowed text-secondary-400 opacity-40',
      )
    "
  >
    <span v-if="disabled" aria-disabled="true">
      {{ label }}
    </span>
    <RouterLink v-else v-slot="{ isActive, isExactActive }" custom :to="to">
      <Link
        :to="to"
        :class="
          cn(
            'hover-effect',
            (exact ? isExactActive : isActive) &&
              'after:origin-bottom-left after:scale-x-100 after:bg-primary-400',
          )
        "
      >
        {{ label }}
      </Link>
    </RouterLink>
  </li>
</template>
